import { coalesceEntriesOrRows } from '@/lib/coalesce-entries-or-rows'

/**
 * Resolves the rotation row list from `GET .../school-schedule/` payloads.
 *
 * Delegates to {@link coalesceEntriesOrRows} so bare arrays are not confused with `{ entries }`.
 */
export function extractRotationWeekdayRowsFromSchedulePayload(
  ext: Record<string, unknown>,
): unknown {
  const rot = ext.rotation_weekday_assignments ?? ext.rotationWeekdayAssignments
  const fromRot = coalesceEntriesOrRows(rot)
  if (fromRot !== undefined) return fromRot
  return ext.rotation_weekday_assignment_entries
}
